export function formatDate(date, dateFormatter) {
    if (date) {
        return dateFormatter(date);
    }
    return "";
}
//# sourceMappingURL=formatDate.js.map